import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { DxTreeViewComponent } from "devextreme-angular/ui/tree-view";

@Component({
  selector: "app-tree-view",
  templateUrl: "./tree-view.component.html",
  styleUrls: ["./tree-view.component.css"]
})
export class TreeViewComponent {
  @Input() items = [];
  @Input() dataStructure = "plain";
  @Input() keyExpr: string;
  @Input() parentIdExpr: string;
  @Input() displayExpr: string;
  @Input() searchEnabled: boolean;
  @Input() height: number;
  @Input() selectionMode = "single";
  @Input() showCheckBoxesMode: string;
  @Output() itemSelected = new EventEmitter<any>();
  @Output() itemsSelected = new EventEmitter<any>();

  @ViewChild("treeViewRef", { static: false }) treeView: DxTreeViewComponent;

  hasPerformedSelection = false;

  constructor() {}

  onContentReady(e: any) {
    if (this.hasPerformedSelection) { return; }
    const component = (e && e.component) || (this.treeView && this.treeView.instance);
    if (component) { component.unselectAll(); }
  }

  onSelectionChanged(e: any) {
    this.hasPerformedSelection = true;

    if (this.selectionMode === "single") {
      this.onSingleSelectionChanged();
      return;
    }

    this.onMultipleSelectionChanged(e.component);
  }

  private onSingleSelectionChanged() {
    const node = this.treeView.instance.getSelectedNodes()[0];
    if (!node) { return; }
    this.itemSelected.emit(node.itemData);
  }

  private onMultipleSelectionChanged(component: any) {
    const selectedItems = component.getSelectedNodes().map(node => node.itemData);
    this.itemsSelected.emit(selectedItems);
  }
}
